import { DateUtil } from "@/utils/chart/date_class.js";
import { isMobile } from "@/utils/chartUtil.js";
// import LightweightCharts from "@/plugin/lightweight_dev.js";
import { createChart } from "lightweight-charts";

export default class PmChartOptions {
  constructor(decimal) {
    // console.log('decimal',decimal);
    const windowWidth = window.innerWidth;

    this.chartOptions = {
      trackingMode: {
        exitMode: 1,
      },
      kineticScroll: {
        mouse: true,
      },
      // width: '90%',
      height: windowWidth <= 576 || isMobile() ? 500 : 700,
      autoSize: true,
      //ao
      leftPriceScale: {
        borderVisible: true,
        visible: false,
        scaleMargins: {
          //가격축 간격
          top: 0.8,
          bottom: 0.0,
        },
        ticksVisible: true,
      },
      //캔들
      rightPriceScale: {
        // autoScale:true,
        visible: true,
        borderColor: "#383F59",
        scaleMargins: {
          top: 0.1,
          //바꾼거!
          bottom: 0.2,
        },
        ticksVisible: true,
      },

      layout: {
        background: { color: "#282828" },
        textColor: "#fff",
        // fontSize:18
        attributionLogo: false,
      },

      grid: {
        vertLines: {
          color: "#383F59",
        },
        horzLines: {
          color: "#383F59",
        },
      },
      timeScale: {
        //hour축 간격
        barSpacing: 11, // barSpacing 값을 11.15로 변경
        timeVisible: true,
        // borderColor: '#505050',
        tickMarkFormatter(time, tickMarkType, locale) {
          return DateUtil.convertTimeScale(time);
        },
        rightOffset: 20,
      },
      crosshair: {
        mode: 0, // CrosshairMode.Normal
      },
      localization: {
        // locale:navigator.language
        timeFormatter(originalTime, timeZone) {
          return DateUtil.convertTimeScaleWithLocal(originalTime, timeZone);
        },
      },
    };

    this.containerId = "";
    this.resizeHandler = () => {
      const windowWidth = window.innerWidth;
      const newHeight = windowWidth <= 576 || isMobile() ? 500 : 700;

      if (this.chart) {
        const containerElement = document.getElementById(this.containerId);
        const containerWidth =
          containerElement.clientWidth || containerElement.offsetWidth;

        containerElement.style.height = newHeight + "px";

        setTimeout(() => {
          this.chart.resize(containerWidth, newHeight);
        }, 100);
      }
    };

    window.addEventListener("resize", this.resizeHandler);
    window.removeEventListener("resize", this.resizeHandler);

    this.candleOptions = {
      title: "Candle",
      priceScaleId: "right",
      priceFormat: {
        type: "price",
        precision: 7,
        minMove: 0.0000001,
      },
      upColor: "#71c3ff",
      borderUpColor: "#71c3ff",
      wickUpColor: "#71c3ff",
      downColor: "#fc5e5e",
      borderDownColor: "#fc5e5e",
      wickDownColor: "#fc5e5e",

      color: "#fff",
    };
    this.pinkOptions = {
      title: "Goya",
      lineWidth: 2,
      priceScaleId: "right",
      priceFormat: {
        type: "price",
        precision: 5,
        minMove: 0.00001,
      },
      color: "#E46EB5",
      topFillColor: "#E46EB5",
      lastValueVisible: true,
    };
    this.aoSeriesOptions = {
      title: "Baseline",
      priceScaleId: "left",
      color: "#2962FF",
      baseValue: {
        type: "price",
        price: 0,
      },
      topLineColor: "#C11C1C",
      // topFillColor1: "rgba( 38, 166, 154, 0.05)",
      // topFillColor2: "rgba(4, 153, 129, 0.2)",

      topFillColor2: "rgba(1, 131, 109, 0.4)",
      // topFillColor2: "blue",
      bottomLineColor: "#00860D",
      // bottomFillColor1: "rgba( 38, 166, 154, 0.28)",
      // bottomFillColor2: "rgba( 38, 166, 154, 0.05)",

      bottomFillColor1: "rgba(242, 54, 69, 0.4)",
      // bottomFillColor2: "rgba( 239, 83, 80, 0.05)",
      lineWidth: 3,
      priceFormat: {
        type: "price",
        precision: 5,
        //   minMove: 0.001,
      },
    };
    this.Ma1Options = {
      title: "7MA",
      priceScaleId: "right",
      lineWidth: 2,
      priceFormat: {
        type: "price",
        precision: 5,
        minMove: 0.00001,
      },
      color: "#fff",
      // topFillColor : 'blue',
    };
    this.Ma2Options = {
      title: "20MA",
      priceScaleId: "right",
      lineWidth: 2,
      priceFormat: {
        type: "price",
        precision: 5,
        minMove: 0.00001,
      },
      color: "#FFF100",
      // topFillColor : 'blue',
    };
    this.Ma3Options = {
      title: "60MA",
      priceScaleId: "right",
      lineWidth: 2,
      priceFormat: {
        type: "price",
        precision: 5,
        minMove: 0.00001,
      },
      color: "#C11C1C",
      // topFillColor : 'blue',
    };
    this.UpperOptions = {
      title: "B",
      priceScaleId: "right",
      lineWidth: 2,
      priceFormat: {
        type: "price",
        precision: 5,
        minMove: 0.00001,
      },
      color: "#E00094",
      // topFillColor : 'red',
    };
    this.LowerOptions = {
      title: "B",
      priceScaleId: "right",
      lineWidth: 2,
      priceFormat: {
        type: "price",
        precision: 5,
        minMove: 0.00001,
      },
      color: "#7DCD5D",
      // topFillColor : 'green',
    };
    this.TrendUpper52Options = {
      title: "trendUpper",
      // lineStyle:1,
      lineWidth: 3,
      priceLineVisible: false,
      priceScaleId: "right",
      priceFormat: {
        type: "price",
        precision: 5,
        minMove: 0.00001,
      },
      color: "orange",
      topFillColor: "orange",
    };
    this.TrendMiddle52Options = {
      title: "52",
      lineStyle: 1,
      lineWidth: 3,
      priceLineVisible: false,
      priceScaleId: "right",
      priceFormat: {
        type: "price",
        precision: 5,
        minMove: 0.00001,
      },
      color: "orange",
      topFillColor: "orange",
    };
    this.TrendLower52Options = {
      title: "trendLower",
      // lineStyle:1,
      lineWidth: 3,
      priceLineVisible: false,
      priceScaleId: "right",
      priceFormat: {
        type: "price",
        precision: 5,
        minMove: 0.00001,
      },
      color: "orange",
      topFillColor: "orange",
    };
    this.TrendUpper100Options = {
      title: "trendUpper",
      // lineStyle:1,
      lineWidth: 3,
      priceLineVisible: false,
      priceScaleId: "right",
      priceFormat: {
        type: "price",
        precision: 5,
        minMove: 0.00001,
      },
      color: "#fff",
      topFillColor: "#fff",
    };
    this.TrendMiddle100Options = {
      title: "100",
      lineStyle: 1,
      lineWidth: 3,
      priceLineVisible: false,
      priceScaleId: "right",
      priceFormat: {
        type: "price",
        precision: 5,
        minMove: 0.00001,
      },
      color: "#FDE707",
      topFillColor: "#FDE707",
    };
    this.TrendLower100Options = {
      title: "trendLower",
      // lineStyle:1,
      lineWidth: 3,
      priceLineVisible: false,
      priceScaleId: "right",
      priceFormat: {
        type: "price",
        precision: 5,
        minMove: 0.00001,
      },
      color: "#fff",
      topFillColor: "#fff",
    };
    this.RSILineOptions = {
      // title:'RSI',
      priceScaleId: "rsi",
      autoScale: false,
      scaleMargins: {
        top: 0.6,
        bottom: 0.1,
      },
      color: "#2962FF",
      baseValue: {
        type: "price",
        price: 0,
      },
      lineWidth: 2,
      priceFormat: {
        type: "price",
        precision: 2,
      },
      priceLineVisible: false,
    };
    this.MACDLineOrangeOptions = {
      priceScaleId: "macd",
      autoScale: false,
      scaleMargins: {
        top: 0.7,
        bottom: 0.1,
      },
      color: "#ff6d00",
      baseValue: {
        type: "price",
        price: 0,
      },
      lineWidth: 2,
      priceFormat: {
        type: "price",
        precision: 5,
        minMove: 0.00001,
      },
      priceLineVisible: false,
    };
    this.MACDLineBlueOptions = {
      // title:'RSI',
      priceScaleId: "macd",
      autoScale: false,
      scaleMargins: {
        top: 0.7,
        bottom: 0.1,
      },
      color: "#2196f3",
      baseValue: {
        type: "price",
        price: 0,
      },
      lineWidth: 2,
      priceFormat: {
        type: "price",
        precision: 5,
        minMove: 0.00001,
      },
      priceLineVisible: false,
    };
    this.MACDHistogramOptions = {
      priceScaleId: "macd",
      autoScale: false,
      scaleMargins: {
        top: 0.7,
        bottom: 0.1,
      },
      color: "#2196f3",
      baseValue: {
        type: "price",
        price: 0,
      },
      lineWidth: 2,
      priceFormat: {
        type: "price",
        precision: 2,
        minMove: 0.01,
      },
      priceLineVisible: false,
    };
    this.MACDRSILineOrangeOptions = {
      title: "macd rsi orange line",
      priceScaleId: "macdrsi",
      autoScale: false,
      color: "#ff6d00",
      lineWidth: 2,
      priceFormat: {
        type: "price",
        precision: 5,
        minMove: 0.00001,
      },
      priceLineVisible: false,
    };
    this.MACDRSILineBlueOptions = {
      title: "macd rsi blue line",
      priceScaleId: "macdrsi",
      autoScale: false,
      color: "#2196f3",
      lineWidth: 2,
      priceFormat: {
        type: "price",
        precision: 5,
        minMove: 0.00001,
      },
      priceLineVisible: false,
    };
    this.rsiPrice70 = {
      price: 70,
      color: "#fff",
      lineWidth: 1,
      lineStyle: 0, // LineStyle.Dashed
      // title: '70',
      axisLabelVisible: true,
      priceFormat: {
        type: "price",
        precision: 0,
        //   minMove: 0.001,
      },
    };
    this.rsiPrice50 = {
      price: 50,
      color: "#eff2ff",
      lineWidth: 1,
      lineStyle: 3, // LineStyle.Dashed
      // title: '50',
      // axisLabelColor:'#2962FF',
      // axisLabelTextColor:"#fff",
      axisLabelVisible: true,
      priceFormat: {
        type: "price",
        precision: 0,
        //   minMove: 0.001,
      },
    };
    this.rsiPrice30 = {
      price: 30,
      color: "#fff",
      lineWidth: 1,
      lineStyle: 0, // LineStyle.Dashed
      // title: '30',
      axisLabelVisible: true,
      priceFormat: {
        type: "price",
        precision: 0,
        //   minMove: 0.001,
      },
    };
    this.senkouaOptions = {
      title: "Smart Line",
      lineWidth: 2,
      priceScaleId: "right",
      priceFormat: {
        type: "price",
        precision: 5,
        minMove: 0.00001,
      },
      color: "yellow",
    };
    this.trend1Options = {
      lineColor: "transparent",
      lastValueVisible: false,
    };
    this.aoPriceLine = {
      price: 0,
      color: "#fff",
      lineWidth: 2,
      lineStyle: 3, // LineStyle.Dashed
      // title: '30',
      axisLabelVisible: true,
      // priceFormat: {
      //     type: 'price',
      //     precision: 0,
      //     //   minMove: 0.001,
      // },
    };
  }
  async createChart(container) {
    this.containerId = container;

    this.chart = createChart(
      document.getElementById(container),
      this.chartOptions
    );

    // 초기 생성 시에도 한 번 resize 적용
    const windowWidth = window.innerWidth;
    const newHeight = windowWidth <= 576 || isMobile() ? 500 : 700;
    this.chart.resize(
      this.chartOptions.width || this.chartWidth || 0,
      newHeight
    );

    return this.chart;
  }
  createSeries(container, type, option, priceFormat, key) {
    if (priceFormat) {
      let { decimalPlaces, decimalScale } = priceFormat;
      if (key != "RSI") {
        // except rsi , all indicator use candle priceScale*0.01
        this[option].priceFormat.precision = Number(decimalPlaces + 2);
        this[option].priceFormat.minMove = Number(
          Number(decimalScale) * 0.01
        ).toFixed(decimalPlaces + 2);
      }
    }

    if (type == "candle") {
      return container.addCandlestickSeries(this[option]);
    } else if (type == "line") {
      return container.addLineSeries(this[option]);
    } else if (type == "baseLine") {
      return container.addBaselineSeries(this[option]);
    } else if (type === "area") {
      return container.addAreaSeries(this[option]);
    } else if (type == "histogram") {
      return container.addHistogramSeries(this[option]);
    } else {
      console.error(`지원되지 않는 타입: ${type}`);

      return;
    }
  }
  getRSIPriceLine(name) {
    return this[`${name}`];
  }
  getAOPriceLine() {
    return this.aoPriceLine;
  }
}
